import { render, staticRenderFns } from "./UserBase.vue?vue&type=template&id=55dd5252"
import script from "./UserBase.vue?vue&type=script&lang=js"
export * from "./UserBase.vue?vue&type=script&lang=js"
import style0 from "./UserBase.vue?vue&type=style&index=0&id=55dd5252&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports